import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFormLibraryUploadCsv = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const uploadCsvToLibrary = async ({ formData }) => {
    setIsLoading(true);
    setResponse(null); // Reset before request
    setError(null);    // Reset before request
    try {
      const res = await axiosInstance.post(`${BASE_URL}v1/form-library/upload-csv/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setResponse(null);
    setError(null);
    setIsLoading(false);
  };

  return { response, error, isLoading, uploadCsvToLibrary, reset };
};

export default useFormLibraryUploadCsv; 